var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.0263 35.0538L1.99977 18.0273L19.0263 1.00086","stroke":"#00443B","strokeWidth":"2"}));
}

LeftArrow.defaultProps = {"width":"20","height":"36","viewBox":"0 0 20 36","fill":"none"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
